import { authenticated } from './WebRequest';
import type { ApiThunk, AxWriteFileParameters } from './types/Plugins';

export type { ApiThunk, AxWriteFileParameters } from './types/Plugins';

export function ax_write_file(params: AxWriteFileParameters): ApiThunk<void> {
  return authenticated.post('/plugins/ax/write_file', params);
}
